// Initialisation de l'objet queryParams pour stocker les paramètres de requête
Shopify.queryParams = {};

// Mode d'application des filtres: false = manuel (via bouton), true = auto (à la volée)
var MM_APPLY_FILTERS_ON_CHANGE = false;

/*********************************************************************************************
* Refresh the collection page with the provided filters.
	* 
	* @param {string} url_filters - The URL parameters for the filters.
*/
function refreshCollectionPageWithFilters(url_filters) {
    let currentUrl = '//' + location.host + location.pathname;
    let newPageString = httpGet(`${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`);
    
    // Créer un nouvel élément DIV pour insérer le HTML récupéré
    let newPageEl = document.createElement('DIV');
    newPageEl.innerHTML = newPageString;

    // Mise à jour des articles de la collection avec les nouveaux filtres
    var newSection = newPageEl.querySelector('.mm-collection-grid-products');
    var currentGrid = document.querySelector('.mm-collection-grid-products');
    if (newSection && currentGrid) {
        currentGrid.innerHTML = newSection.innerHTML;
    }

    // Mise à jour des filtres actifs
    var activeFilters = newPageEl.querySelectorAll('.active-filters');
    activeFilters.forEach(function (activeFilter) {
        var newActiveFilters = document.querySelectorAll('.active-filters');
        newActiveFilters.forEach(function (newActiveFilter) {
            if (newActiveFilter) {
                newActiveFilter.innerHTML = activeFilter.innerHTML;
            }
        });
    });
    
    // Mise à jour des autres éléments avec la classe 'mm-reload'
    var reloadElems = newPageEl.querySelectorAll('.mm-reload');
    reloadElems.forEach(function (reloadElem, index) {
        var newElems = document.querySelectorAll('.mm-reload');
        if (newElems[index]) {
            newElems[index].innerHTML = reloadElem.innerHTML;
        }
    });

    // Synchroniser la valeur du select visible avec le paramètre sort_by
    try {
        const params = new URLSearchParams(url_filters);
        const sortByParam = params.get('sort_by');
        if (sortByParam) {
            const visibleSort = document.getElementById('SortBy');
            if (visibleSort) {
                visibleSort.value = sortByParam;
            }
        }
    } catch (e) {
        // no-op
    }

    // Mise à jour de l'URL dans l'historique sans recharger la page
    window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);
    var gridForLoading = document.querySelector('.mm-collection-grid-products');
    if (gridForLoading) {
        gridForLoading.classList.remove('mm-loading');
    }
    
    // Vérifie les changements dans les filtres après le rafraîchissement
    checkForChanges();
}

/*********************************************************************************************
* Return the Shopify section ID of the collection grid.
	* 
	* @returns {string} - The section ID of the grid.
*/
function returnShopifySectionId() {
    const gridElem = document.querySelector('.mm-collection-grid');
    if (!gridElem) { return ''; }
    const gridSection = gridElem.closest('.shopify-section');
    if (!gridSection) { return ''; }
    return gridSection.id || '';
}

/*********************************************************************************************
* Return the Shopify section ID without the 'shopify-section-' prefix.
	* 
	* @returns {string} - The shortened section ID.
*/
function returnShopifySectionIdShort() {
    const fullId = returnShopifySectionId();
    if (!fullId) { return ''; }
    return fullId.replace('shopify-section-', '');
}

/*********************************************************************************************
* Perform a synchronous GET request.
	* 
	* @param {string} theUrl - The URL to request.
	* @returns {string} - The response text from the request.
*/
function httpGet(theUrl) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open('GET', theUrl, false);  // Synchronous request
    xmlHttp.send(null);
    return xmlHttp.responseText;
}

// Debounce global pour éviter les soumissions en rafale
var __mmFakeSubmitTimeout = null;

// Stockage de l'état initial des filtres pour détecter les changements
var __mmInitialFilterState = null;

/*********************************************************************************************
* Capture l'état initial des filtres lors de l'ouverture
*/
function captureInitialFilterState() {
    const forms = document.querySelectorAll('.mm-filter-form-item-form');
    if (!forms || forms.length === 0) { 
        __mmInitialFilterState = null;
        return; 
    }

    const params = new URLSearchParams();
    forms.forEach(function(f) {
        const fd = new FormData(f);
        for (const [key, value] of fd.entries()) {
            params.append(key, value);
        }
    });
    
    // Stocker l'état initial trié pour comparaison
    __mmInitialFilterState = params.toString();
}

/*********************************************************************************************
* Vérifie si des filtres ont été modifiés depuis l'ouverture
* 
* @returns {boolean} - true si des changements ont été détectés
*/
function hasFiltersChanged() {
    if (!__mmInitialFilterState) { return false; }
    
    const forms = document.querySelectorAll('.mm-filter-form-item-form');
    if (!forms || forms.length === 0) { return false; }

    const currentParams = new URLSearchParams();
    forms.forEach(function(f) {
        const fd = new FormData(f);
        for (const [key, value] of fd.entries()) {
            currentParams.append(key, value);
        }
    });
    
    const currentState = currentParams.toString();
    return currentState !== __mmInitialFilterState;
}

/*********************************************************************************************
* Check for changes using event delegation to avoid multiplying listeners.
* 
*/
function checkForChanges() {
    const container = document.querySelector('.mm-filter-form');
    if (!container) { return; }
    // En mode manuel, on ne lie pas de listeners sur change
    if (MM_APPLY_FILTERS_ON_CHANGE === false) { return; }
    if (container.dataset.mmChangeBound === '1') { return; }

    container.addEventListener('change', function(e) {
        const t = e.target;
        if (!t) { return; }
        if (t.tagName === 'INPUT') {
            fakeSubmitForm();
        }
    });

    // Marqueur pour ne pas rebinder après refresh
    container.dataset.mmChangeBound = '1';
}

/*********************************************************************************************
* Update the sort_by query parameter and reload the page with the new sorting applied.
	* 
	* @param {HTMLSelectElement} select - The select element for sorting.
*/
function mmSortByChanged(select) {
    const hiddenSelect = document.getElementById('mmSortByHiddenElem');
    if (hiddenSelect) {
        hiddenSelect.value = select.value;
        fakeSubmitForm();
        return;
    }

    const form = document.querySelector('.mm-filter-form-item-form');
    if (form && form.contains(select)) {
        // Le select est dans le formulaire, la sérialisation l’inclura
        fakeSubmitForm();
        return;
    }

    // Fallback: mise à jour via query param (au cas où le select est hors formulaire)
    Shopify.queryParams.sort_by = select.value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
}

/*********************************************************************************************
* Adds a listener on the change of select for sorting
	* 
*/
var sortByElem = document.querySelector('.sort_by');
if (sortByElem) {
    sortByElem.addEventListener('change', function(e) {
        var value = e.target.value;
        Shopify.queryParams.sort_by = value;
        location.search = new URLSearchParams(Shopify.queryParams).toString();
    });
}

/*********************************************************************************************
* Serialize the form data and refresh the collection page with the filters.
	*
*/
function fakeSubmitForm() {
    // Agréger les données de tous les formulaires de filtres (même id répété)
    const forms = document.querySelectorAll('.mm-filter-form-item-form');
    if (!forms || forms.length === 0) { return; }

    const params = new URLSearchParams();
    forms.forEach(function(f) {
        const fd = new FormData(f);
        for (const [key, value] of fd.entries()) {
            params.append(key, value);
        }
    });
    let url_filters = params.toString();
    var grid = document.querySelector('.mm-collection-grid-products');
    if (grid) {
        grid.classList.add('mm-loading');
    }

    console.log('call fakeSubmitForm');
    
    // Rafraîchir la collection avec les filtres
    if (__mmFakeSubmitTimeout) {
        clearTimeout(__mmFakeSubmitTimeout);
    }
    __mmFakeSubmitTimeout = setTimeout(function() {
        refreshCollectionPageWithFilters(url_filters);
        __mmFakeSubmitTimeout = null;
    }, 50);
}

/*********************************************************************************************
* Loaded Listenner
	*
*/
window.addEventListener('DOMContentLoaded', (event) => {
    checkForChanges();
    // Accessibilité filtres: prise en charge clavier/souris uniforme
    (function() {
        const container = document.querySelector('.mm-filter-form');
        if (!container) return;

        // Entrée sur input checkbox => simuler click pour garder logique native et events
        container.addEventListener('keydown', function(e) {
          const t = e.target;
          if (!t) return;
          if (t.tagName === 'INPUT' && t.type === 'checkbox') {
            if (e.key === 'Enter') {
              e.preventDefault();
              t.click();
            }
          }
        });

        // Entrée/Espace sur label focusable => activer l'input lié via click()
        container.addEventListener('keydown', function(e) {
          const t = e.target;
          if (!t) return;
          if (t.tagName === 'LABEL') {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const forId = t.getAttribute('for');
              if (!forId) return;
              const input = document.getElementById(forId);
              if (input && input.type === 'checkbox') {
                input.click();
              }
            }
          }
        });

        // Compat keyup pour certains navigateurs
        container.addEventListener('keyup', function(e) {
          const t = e.target;
          if (!t) return;
          if (t.tagName === 'LABEL') {
            if (e.key === ' '){
              e.preventDefault();
            }
          }
        });
    })();
});
